import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useSession } from './session';
import { PageSpinner } from '@/components/ui/PageSpinner';

/** Signed in, and past the forced password change. */
export function RequireUser() {
  const { data: me, isPending } = useSession();
  const location = useLocation();
  if (isPending) return <PageSpinner />;
  if (!me) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (me.user.mustChangePassword && location.pathname !== '/account/password') {
    return <Navigate to="/account/password" replace />;
  }
  return <Outlet />;
}

export function RequireAdmin() {
  const { data: me } = useSession();
  if (!me?.user.isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}

/** The `:sellerId` in the URL must be a seller the person may act on. */
export function RequireSeller() {
  const { data: me } = useSession();
  const { sellerId } = useParams<{ sellerId: string }>();
  const seller = me?.sellers.find((s) => s.id === sellerId);
  if (!seller) return <Navigate to={me?.user.isAdmin ? '/admin/sellers' : '/no-seller'} replace />;
  return <Outlet context={seller} />;
}
